import axiosInstance from "./axiosInstance";


export const getNeedsAttention = async (projectId) => {
  const response = await axiosInstance.get(
    `/projects/${projectId}/needs-attention`,
  );
  return response.data;
};

export const sendClientReminder = async (householdId) => {
  const response = await axiosInstance.post(
    `/households/${householdId}/send-to-client`,
    {},
  );
  return response.data;
};


export const updateHouseholdStatus = async (householdId, payload) => {
  const response = await axiosInstance.put(
    `/households/${householdId}/status`,
    payload,
  );
  return response.data;
};
